import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"

import { storeTimeoutModalIsOpen } from "actions"

const useTimeout = () => {
  const dispatch = useDispatch()
  return {
    timeoutModalIsOpen: useSelector(state => state.timeout.timeoutModalIsOpen),
    storeTimeoutModalIsOpen: useCallback(
      props => dispatch(storeTimeoutModalIsOpen(props)),
      [dispatch]
    ),
  }
}
export default useTimeout
